import { Link } from "react-router-dom";
import { CATEGORY_META } from "@/mocks/films";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center text-lg">
                <i className="ri-clapperboard-line" />
              </span>
              <span className="font-heading text-lg font-semibold text-white">欧美成人电影</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              专注于欧美成人影视作品的资料整理与资讯展示，提供影片剧情、演员信息、分类筛选与编辑推荐，帮助成人观众快速了解影片内容。
            </p>
            <div className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-800 text-[11px] tracking-wide text-accent-300">
              <i className="ri-shield-check-line" />
              18+ 成人内容 · 仅限成年观众浏览
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 flex items-center gap-2">
              <Link to="/category/drama" className="hover:text-accent-300 transition-colors">
                影片分类
              </Link>
            </h4>
            <ul className="space-y-2.5">
              {CATEGORY_META.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-accent-300 transition-colors inline-flex items-center gap-1.5"
                  >
                    <i className={`${cat.icon} text-xs text-background-400`} />
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 flex items-center gap-2">
              <Link to="/about" className="hover:text-accent-300 transition-colors">
                站点导航
              </Link>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-accent-300 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/search?q=剧情"
                  className="text-sm text-background-300 hover:text-accent-300 transition-colors"
                >
                  搜索影片
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-accent-300 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-accent-300 transition-colors">
                  免责声明
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-accent-300 transition-colors">
                  联系方式
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">编辑说明</h4>
            <p className="text-sm leading-relaxed text-background-300">
              本站所有影片资料均由编辑团队整理，仅用于作品介绍与资讯展示，不保存、不提供任何影片资源文件及播放、下载入口。
            </p>
            <p className="mt-4 text-sm text-background-300">
              内容纠错与合作：
              <a
                href="mailto:editor@eurasia-film.example"
                className="ml-1 text-accent-300 hover:text-accent-200 break-all"
              >
                editor@eurasia-film.example
              </a>
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2026 欧美成人电影 · 影视资讯与资料整理展示 · 保留所有权利
          </p>
          <p className="text-xs text-background-400">
            本站为内容介绍站点，不存储任何影片文件
          </p>
        </div>
      </div>
    </footer>
  );
}